import DialogComponent from "components/Dialog";

import Table from "components/Table";

export default class TreatmentPlanDetailDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.defaultState = {
            ...this.state,
        };

        this.state = { ...this.defaultState };

        this.tableMap = {
            teeth: {
                label: "client.teeth",
                type: "teeth",
            },
            title: {
                label: "main.work",
                size: "40%"
            },
            disc: {
                label: "main.sum",
                type: "sum",
                size: "100px"
            },
            paied: {
                label: "directionType.substract",
            },
            diary: {
                label: "client.diary",
            },
        };

    }

    get formClass() {
        return "h100";
    }

    show(info) {
        this.info = info || {};

        this.dialogTitle = this.info.title;

        super.show();
    }

    formatWorks(works) {
        /*return (works || []).flatMap(it => {
            const { teeth, price, count, discount, noDiscount } = it;
            const tt = teeth?.length > 0 ? teeth : [100];

            const sum = (price || 0) * (count || 0) * tt.length;
            let disc = sum;
            if (!noDiscount && discount)
                disc = this._helper.number.percentMinus(disc, discount);

            return tt.map(t => {
                return { ...it, teeth: t, sum, disc };
            });
        });*/

        return (works || []).map(it => {
            const { teeth, price, count, discount, noDiscount } = it;
            const tt = teeth?.length > 0 ? teeth : [100];
            const sum = (price || 0) * (count || 0);
            let disc = sum;
            if (!noDiscount && discount)
                disc = this._helper.number.percentMinus(disc, discount);

            return { ...it, teeth: tt, sum, disc };
        });

    }

    renderButtons() {
        return <></>;
    }

    renderContent() {
        const items = this.formatWorks(this.info?.preSecuredInvoice?.securedInvoiceItems);

        return (
            <div className="content flex col gap24">
                <div className="tableBlock rad8" style={{ width: "1000px" }}>
                    <Table
                        map={this.tableMap}
                        items={items}
                        scrollNo={true}
                        cantSort={true}
                        transparentBorder={true}
                    />
                </div>
            </div>
        );
    }
}
